import React from 'react'
import './Spear.css'

export default function Spear() {
  return (
    <div className='wizardSpear'>
      <div className='wizardUpperSpear'></div>
      <div className='wizardLowerSpear'></div>
    </div>
  )
}
